import { ChangeDetectionStrategy, Component } from "@angular/core";
import { SkeletonComponent } from "@claas/claas-ui-components";

/**
 * Generic loading placeholder for CoreMedia content. Deliberately content-type agnostic:
 * one media block plus a heading and text lines, sized to roughly occupy the space a
 * rendered item takes so the page does not jump once the real content arrives.
 */
@Component({
  selector: "claas-content-skeleton",
  templateUrl: "./content-skeleton.html",
  styleUrls: ["./content-skeleton.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SkeletonComponent],
})
export class ContentSkeletonComponent {}
